import {Http} from '@/model/Http.js'

export default class pay extends Http {
  /**
   * 获取套餐列表
   * @param data
   * @param url
   * @param method
   * @returns {*}
   */
  getSetList(data) {
    const url = '/movie/open/open-movie-package/query-package'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 开通分销
   * @param data
   * @returns {*}
   */
  openProfit(data) {
    const url = '/movie/open/open-movie-package-order/open'
    return this.postAjaxByMini(url, data)
  }
  /**
   * POI券新-上下架
   * @param data
   * @returns {*}
   */
  shelfCoupon(data) {
      const url = '/open/open/market/coupon/activity/product-operate'
      return this.postAjaxByMini(url, data)
    }

  /**
   * 获取支付二维码
   * @param data
   * @returns {*}
   */
  getPayCode(data) {
    const url = '/movie/open/pay/package-scan-pay'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 获取支付状态
   * @param data
   * @returns {*}
   */
  getPayStatus(data) {
    const url = '/movie/open/open-movie-package-order/get-status'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 获取购买小程序席位数量
   * @param data
   * @returns {*}
   */
  getMiniNum(data) {
    const url = '/movie/open/open-app/query'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 添加商户号
   * @param data
   * @returns {*}
   */
  addMini(data) {
    const url = '/movie/open/merchant/add'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 绑定商户号
   * @param data
   * @returns {*}
   */
  bindMini(data) {
    const url = '/movie/open/merchant-relation/bind'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 绑定官方商户号
   * @param data
   * @returns {*}
   */
  bindMiniGf(data) {
    const url = '/movie/open/merchant-relation/bind-official'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 获取小程序appKey
   * @param data
   * @returns {*}
   */
  getMiniAppKey(data) {
    const url = '/movie/open/open-app/find'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 小程序补差升级
   * @param data
   * @returns {*}
   */
  updatePackage(data) {
    const url = '/movie/open/open-movie-package-order/upgrade'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 小程序续费
   * @param data
   * @returns {*}
   */
  continuePackage(data) {
    const url = '/movie/open/open-movie-package-order/continues'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 小程序用户列表
   * @param data
   * @returns {*}
   */
  getMiniUserList(data) {
    const url = '/movie/open/open-fans/search'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 小程序用户详情
   * @param data
   * @returns {*}
   */
  getMiniUserDetail(data) {
    const url = '/movie/open/open-fans/details'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 小程序状态
   * @param data
   * @returns {*}
   */
  alterStatus(data) {
    const url = '/movie/open/open-fans/update-status'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 小程序资金明细
   * @param data
   * @returns {*}
   */
  financialDetails(data) {
    const url = '/movie/open/open-app-balance-log/search'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 小程序资金明细
   * @param data
   * @returns {*}
   */
  withdrawalAudit(data) {
    const url = '/movie/open/user-withdraw-audit/search'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 小程序查询是否可以设置为总监
   * @param data
   * @returns {*}
   */
  queryJunior(data) {
    const url = '/movie/open/open-fans/query-Junior'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 小程序查询设置为总监
   * @param data
   * @returns {*}
   */
  updateMajor(data) {
    const url = '/movie/open/open-fans/update-Major'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 小程序查询取消设置为总监
   * @param data
   * @returns {*}
   */
  cancelMajor(data) {
    const url = '/movie/open/open-fans/cancel-Major'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 小程序打款
   * @param data
   * @returns {*}
   */
  remitMini(data) {
    const url = '/movie/open/user-withdraw-audit/transfer'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 小程序驳回
   * @param data
   * @returns {*}
   */
  remitBackMini(data) {
    const url = '/movie/open/user-withdraw-audit/reject'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 小程序推广设置
   * @param data
   * @returns {*}
   */
  setTgMini(data) {
    const url = '/movie/open/open-movie-app-append/update'
    return this.postAjaxByMiniNew(url, data)
  }

  /**
   * 小程序推广设置查询
   * @param data
   * @returns {*}
   */
  setTgMiniSearch(data) {
    const url = '/movie/open/open-movie-app-append/find'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 小程序提现设置查询
   * @param data
   * @returns {*}
   */
  setTxMiniSearch(data) {
    const url = '/movie/open/params_withdraw/find\n'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 小程序提现设置
   * @param data
   * @returns {*}
   */
  setTxMini(data) {
    const url = '/movie/open/params_withdraw/update'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 小程序邀请海报设置
   * @param data
   * @returns {*}
   */
  setPosterMiniSearch(data) {
    const url = '/movie/open/params_post/query'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 小程序删除邀请海报设置
   * @param data
   * @returns {*}
   */
  deletePoster(data) {
    const url = '/movie/open/params_post/delete-self-poster'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 小程序保存邀请海报设置
   * @param data
   * @returns {*}
   */
  upadtePoster(data) {
    const url = '/movie/open/params_post/update'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 小程序充值信息
   * @param data
   * @returns {*}
   */
  getRecharge(data) {
    const url = '/movie/open/open-recharge-detail/get-recharge'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 小程序充值二维码
   * @param data
   * @returns {*}
   */
  changeAlipayQrcode(data) {
    const url = '/movie/open/open-recharge-detail/recharge'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 小程序充值
   * @param data
   * @returns {*}
   */
  recharge(data) {
    const url = '/movie/open/open-recharge-detail/recharge'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 小程序提现信息
   * @param data
   * @returns {*}
   */
  openGetLimit(data) {
    const url = '/movie/open/open-app-withdraw/get-withdraw'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 小程序添加银行卡
   * @param data
   * @returns {*}
   */
  addBankCard(data) {
    const url = '/movie/open/open-bank-card-info/add'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 小程序银行卡列表
   * @param data
   * @returns {*}
   */
  getBankCardList(data) {
    const url = '/movie/open/open-bank-card-info/bank-list'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 小程序我的银行卡列表
   * @param data
   * @returns {*}
   */
  getMyBankCardList(data) {
    const url = '/movie/open/open-bank-card-info/search'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 小程序自动识别银行卡
   * @param data
   * @returns {*}
   */
  openRecognitionBank(data) {
    const url = '/movie/open/open-bank-card-info/distinguish'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 小程序删除银行卡
   * @param data
   * @returns {*}
   */
  deleteBankCard(data) {
    const url = '/movie/open/open-bank-card-info/del'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 小程序sxy提现
   * @param data
   * @returns {*}
   */
  openSxyWithdraw(data) {
    const url = '/movie/open/open-app-withdraw/withdraw-kk'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 发送短信
   * @param data
   * @returns {*}
   */
  sendSmsCode(data) {
    const url = '/movie/open/open-app-withdraw/send-sms-code'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 小程序提现列表
   * @param data
   * @returns {*}
   */
  withdrawList(data) {
    const url = '/movie/open/open-app-withdraw/search'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 小程序设置
   * @param data
   * @returns {*}
   */
  setMini(data) {
    const url = '/movie/open/open-app/mini-info'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 同步消息模版
   * @param data
   * @returns {*}
   */
  miniMessage(data) {
    const url = '/movie/open/app-template/mini-sub-add'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 商户号
   * @param data
   * @returns {*}
   */
  getMiniShh(data) {
    const url = '/movie/open/merchant-relation/info'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 修改商户号
   * @param data
   * @returns {*}
   */
  editMiniShh(data) {
    const url = '/movie/open/merchant/edit'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 其他设置
   * @param data
   * @returns {*}
   */
  otherSettings(data) {
    const url = '/movie/open/open-movie-app-append/other-edit-info'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 其他设置
   * @param data
   * @returns {*}
   */
  saveOtherSettings(data) {
    const url = '/movie/open/open-movie-app-append/other-edit'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 影票订单
   * @param data
   * @returns {*}
   */
  getOrderList(data) {
    const url = '/movie/open/open-movie-order/search'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 影票订单
   * @param data
   * @returns {*}
   */
  getOrderDetail(data) {
    const url = '/movie/open/open-movie-order/detail'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 影票拦截订单
   * @param data
   * @returns {*}
   */
  orderIntercept(data) {
    const url = '/movie/open/open-movie-order-intercept/order-intercept'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 主页数据
   * @param data
   * @returns {*}
   */
  getHomeData(data) {
    const url = '/movie/open/open-movie-day-stat/get-home'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 催出票
   * @param data
   * @returns {*}
   */
  pushOut(data) {
    const url = '/movie/open/open-movie-order-intercept/ticket-notify'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 折线图
   * @param data
   * @returns {*}
   */
  getChart(data) {
    const url = '/movie/open/open-movie-day-stat/query'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 折线图v3.1.15
   * @param data
   * @returns {*}
   */
  getChartMovieDay(data) {
    const url = '/movie/open/open-movie-day-stat/query-line'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 折线图
   * @param data
   * @returns {*}
   */
  alipayWithdraw(data) {
    const url = '/movie/open/open-app-withdraw/withdraw-alipay'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 影票订单导出
   * @param data
   * @returns {*}
   */
  exportMovieOrder(data) {
    const url = '/movie/open/open-movie-order/export'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 用户列表导出
   * @param data
   * @returns {*}
   */
  exportMovieUser(data) {
    const url = '/movie/open/open-fans/export'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 用户列表导出
   * @param data
   * @returns {*}
   */
  exportMovieAudit(data) {
    const url = '/movie/open/user-withdraw-audit/export'
    return this.postAjaxByMiniExport(url, data)
  }

  /**
   * 资金明细导出
   * @param data
   * @returns {*}
   */
  exportMovieDetail(data) {
    const url = '/movie/open/open-app-balance-log/export'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 取消拦截
   * @param data
   * @returns {*}
   */
  cancelIntercept(data) {
    const url = '/movie/open/open-movie-order-intercept/cancel-order-intercept'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 添加子账号
   * @param data
   * @returns {*}
   */
  addAccount(data) {
    const url = '/open/open/user/add-sub-user'
    return this.postAjaxByMini(url, data)
  }

  // getCode(data){
  //   const url = '/open/open/user/send'
  //   return this.postAjaxByMini(url, data)
  // }
  /**
   * 子账号列表
   * @param data
   * @returns {*}
   */
  getAccountSub(data) {
    const url = '/open/open/user/search-sub-user'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 设置子账号状态
   * @param data
   * @returns {*}
   */
  setAccountStatus(data) {
    const url = '/open/open/user/set-status'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 删除子账号
   * @param data
   * @returns {*}
   */
  deleteAccount(data) {
    const url = '/open/open/user/batch-del'
    return this.postAjaxByMini(url, data)
  }

  // 推广位管理 列表查询
  getPromotePage(data) {
    const url = '/movie/open/promote-info/search'
    return this.postAjaxByDouYin(url, data)
  }

  // 推广位管理 代理推广位列表
  getPromoteList(data) {
    const url = '/movie/open/promote-info/query-promote'
    return this.postAjaxByDouYin(url, data, true)
  }

  // 推广位管理 代理的应用小程序列表
  getMiniAppList(data) {
    const url = '/movie/open/promote-info/query-dy-app'
    return this.postAjaxByDouYin(url, data)
  }

  // 推广位管理 新增
  addPromote(data) {
    const url = '/movie/open/promote-info/add'
    return this.postAjaxByDouYin(url, data)
  }

  // 推广位管理 编辑
  editPromote(data) {
    const url = '/movie/open/promote-info/modify'
    return this.postAjaxByDouYin(url, data)
  }

  // 推广位管理 获取详情
  getPromoteDetail(data) {
    const url = '/movie/open/promote-info/go-modify'
    return this.postAjaxByDouYin(url, data)
  }

  // 推广位管理 删除
  delPromote(data) {
    const url = '/movie/open/promote-info/batch-delete'
    return this.postAjaxByDouYin(url, data, true)
  }

  // 推广位管理 统计数据
  statSearch(data) {
    const url = '/movie/open/promote-info/stat-search'
    return this.postAjaxByDouYin(url, data)
  }

  // 推广位管理 统计数据导出
  statExport(data) {
    const url = '/movie/open/promote-info/stat-export'
    return this.postAjaxByMiniExport(url, data)
  }

  // 优惠券管理 - 添加新优惠券
  addCoupon(data) {
    const url = '/open/open/open-coupon/add'
    return this.postAjaxByMini(url, data)
  }

  // 优惠券管理 - 编辑新优惠券
  editCoupon(data) {
    const url = '/open/open/open-coupon/edit'
    return this.postAjaxByMini(url, data)
  }

  //活动功能开关
  switchActivity(data) {
    const url = '/open/open/open-coupon/activity-switch'
    return this.postAjaxByMini(url, data)
  }

  // 优惠券管理 - 优惠券功能开关 - 回显
  getCoupon(data) {
    const url = '/open/open/open-coupon/get-coupon'
    return this.postAjaxByMini(url, data)
  }

  // 优惠券管理 - 修改启用状态
  modifyCouponStatus(data) {
    const url = '/open/open/open-coupon/modify-status'
    return this.postAjaxByMini(url, data)
  }

  // 优惠券管理 - 优惠券列表
  searchCoupon(data) {
    const url = '/open/open/open-coupon/search'
    return this.postAjaxByMini(url, data)
  }

  // 优惠券使用情况 - 导出
  exportCouponDetail(data) {
    const url = '/open/open/open-coupon-detail/export'
    return this.postAjaxByMiniExport(url, data)
  }

  // 活动管理 - 导出
  exportCoupon(data) {
    const url = '/open/open/open-coupon/export'
    return this.postAjaxByMiniExport(url, data)
  }
  // 活动管理 - 导出
  exportCouponActivity(data) {
    const url = '/open/open/market/coupon/activity/export'
    return this.postAjaxByMiniExport(url, data)
  }

  // 优惠券使用情况 - 列表
  searchCouponDetail(data) {
    const url = '/open/open/open-coupon-detail/search'
    return this.postAjaxByMini(url, data)
  }

  // 小程序主是否拥有优惠券权限
  userCoupon(data) {
    const url = '/open/open/open-coupon/user-coupon'
    return this.postAjaxByMini(url, data)
  }

  // 优惠券活动
  getActivities(data) {
    const url = '/open/open/open-coupon-activity/activities'
    return this.postAjaxByMini(url, data)
  }

  //程序资金转移到账户中心
  transferAccountCenter(data) {
    const url = '/movie/open/open-recharge-detail/money-transfer'
    return this.postAjaxByMini(url, data)
  }

  //优惠券管理影院分类
  cinemaClassifyList(data) {
    const url = '/open/open/open-cinema-classify/search'
    return this.postAjaxByMini(url, data)
  }

  //根据影院编码查询影院 - 影院分类列表
  findCinemaByStandardId(data) {
    const url = '/open/open/open-cinema-classify/findCinemaById'
    return this.postAjaxByMini(url, data)
  }

  //根据影院分类Id查询是否禁用 - 影院分类列表
  findEnableByIds(data) {
    const url = '/open/open/open-cinema-classify/findEnableByIds'
    return this.postAjaxByMini(url, data)
  }

  //id查询当前列表数据
  getByIdcoupon(data) {
    const url = '/open/open/open-coupon/getById'
    return this.postAjaxByMini(url, data)
  }

  zfbMiniAuth(data) {
    const url = '/movie/open/auth/zfb-mini-auth'
    return this.getAjaxByMini(url, data)
  }


  // 优惠券使用情况-导出
  ksLifeCouponExport(data) {
    const url = '/open/open/ks-life-coupon/export'
    return this.postAjaxByMiniExport(url, data)
  }

  // 优惠券使用情况-列表
  ksLifeCouponSearch(data) {
    const url = '/open/open/ks-life-coupon/search'
    return this.postAjaxByMini(url, data)
  }

  // 判断是否有权限
  getConfigGet(data) {
    const url = '/movie/open/config/get'
    return this.postAjaxByMini(url, data, true)
  }

  // 抖音小程序券-优惠券管理 - 优惠券列表
  searchCouponDy(data) {
    const url = '/open/open/open-dy-coupon/search'
    return this.postAjaxByMini(url, data)
  }

  // 抖音-优惠券使用情况 - 导出
  openDyCouponExport(data) {
    const url = '/open/open/open-dy-coupon/export'
    return this.postAjaxByMiniExport(url, data)
  }

  // 抖音-优惠券管理 - 创建新优惠券
  dyCouponSave(data) {
    const url = '/open/open/open-dy-coupon/save'
    return this.postAjaxByMiniNew(url, data)
  }

  // 抖音-优惠券使用情况列表
  dyCouponUseSearch(data) {
    const url = '/open/open/open-dy-coupon/useSearch'
    return this.postAjaxByMini(url, data)
  }

  // 抖音-优惠券使用情况 - 导出
  useSearchExportDy(data) {
    const url = '/open/open/open-dy-coupon/useSearch-export'
    return this.postAjaxByMiniExport(url, data)
  }

  // 快手商品券同步-列表
  ksLifeCouponQuery(data) {
    const url = '/movie/open/ks-life-coupon/query'
    return this.postAjaxByMini(url, data)
  }

  ksLifeCouponQueryV3(data) {
    const url = '/movie/open/ks-life-coupon/query-V3'
    return this.postAjaxByMini(url, data)
  }

  // 快手商品券同步-同步商品信息
  ksLifeCouponCoupon(data) {
    const url = '/movie/open/ks-life-coupon/sync-coupon'
    return this.postAjaxByMini(url, data)
  }

  ksLifeCouponCouponV3(data) {
    const url = '/movie/open/ks-life-coupon/sync-coupon-V3'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 淘宝OCR人工纠错列表
   */
  taobaoOcrCorrectList(data) {
    const url = '/open/open/manual-correct/list'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 淘宝OCR人工店铺列表
   * /open/open/manual-correct/shop-list
   * GET shopName
   */
  taobaoOcrShopList(data) {
    const url = '/open/open/manual-correct/shop-list'
    return this.getAjaxByMini(url, data)
  }

  updateOcrLose(data) {
    const url = '/open/open/ticket-royalty-mode/update-ocr-lose'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 淘宝OCR城市列表搜索
   * /open/open/base-data/get-city-base
   * GET {cityName:""}
   */
  taobaoOcrCityList(data) {
    const url = '/open/open/base-data/get-city-base'
    return this.getAjaxByMini(url, data)
  }

  /**
   * 淘宝OCR获取影院
   * /open/open/base-data/get-cinema-base
   * GET data {cityId:"",cinemaName:""}
   */
  taobaoOcrCinemaList(data) {
    const url = '/open/open/base-data/get-cinema-base'
    return this.getAjaxByMini(url, data)
  }

  /**
   * 淘宝OCR 影片模糊搜索
   * /open/open/base-data/get-film-list
   * GET data {filmName:""}
   */
  taobaoOcrFilmList(data) {
    const url = '/open/open/base-data/get-film-list'
    return this.getAjaxByMini(url, data)
  }

  /**
   * 淘宝OCR 排期模糊搜索
   * /open/open/base-data/get-film-schedule
   * GET data {cinemaName:"",filmName:"",showTime:""}
   */
  taoBaoOcrScheduleList(data) {
    const url = '/open/open/base-data/get-film-schedule'
    return this.getAjaxByMini(url, data)
  }

  /**
   * 淘宝OCR 移除订单
   * /open/open/manual-correct/remove-order
   * POST data {id:'',remark:''}
   */
  taobaoOcrRemoveOrder(data) {
    const url = '/open/open/manual-correct/remove-order'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 淘宝OCR 关闭订单
   * /open/open/manual-correct/close-and-push
   * POST data {id:'',closeRemark:'' ,pushContent:""}
   */
  taobaoOcrCloseOrder(data) {
    const url = '/open/open/manual-correct/close-and-push'
    return this.postAjaxByMini(url, data)
  }

  /**
   * 淘宝OCR 订单推送
   * /open/open/manual-correct/rate-price-and-push
   * POST data {acceptChangeSeat:"",cinemaName:"",cityName:"",hallName:"",id:"",movieName:"",seat:"",showTime:""}
   */
  taobaoOcrPushOrder(data) {
    const url = '/open/open/manual-correct/rate-price-and-push'
    return this.postAjaxByMini(url, data)
  }

  taobaoOcrRatePrice(data) {
    const url = '/open/open/manual-correct/rate-price-and-order'
    return this.postAjaxByMini(url, data)
  }

  // 支付宝-列表
  zfbActivityPage(data) {
    const url = '/open/open/activity/page'
    return this.postAjaxByMiniNew(url, data)
  }
  // 停用
  zfbActivityStop(data) {
    const url = '/open/open/activity/stop'
    return this.postAjaxByMini(url, data)
  }
  // 查询数量
  zfbQueryQuantityBeforeAppend(data) {
    const url = '/open/open/activity/queryQuantityBeforeAppend'
    return this.getAjaxByMini(url, data)
  }
  // 追加数量
  zfbActivityAppendCode(data) {
    const url = '/open/open/activity/appendCode'
    return this.postAjaxByMini(url, data)
  }

  // 活动详情
  zfbActivityDetail(data) {
    const url = '/open/open/activity/detail'
    return this.postAjaxByMini(url, data)
  }
  // 支付宝-活动创建
  zfbActivityCreate(data) {
    const url = '/open/open/activity/create'
    return this.postAjaxByMiniNew(url, data)
  }
  // 支付宝-活动编辑
  zfbActivityEdit(data) {
    const url = '/open/open/activity/edit'
    return this.postAjaxByMiniNew(url, data)
  }
  // 优惠券使用情况-列表
  zfbLifeCouponSearch(data) {
    const url = '/open/open/third-life-coupon/search'
    return this.postAjaxByMini(url, data)
  }
  // 优惠券使用情况-导出
  lifeCouponExport(data) {
    const url = '/open/open/third-life-coupon/export-v3'
    return this.postAjaxByMiniExport(url, data)
  }

  // 抖音券使用情况-列表
  dyLifeCouponSearch(data) {
    const url = '/open/open/third-life-coupon/search'
    return this.postAjaxByMini(url, data)
  }

  // 抖音券使用情况-导出
  dyLifeCouponExport(data) {
    const url = '/open/open/third-life-coupon/export-v3'
    return this.postAjaxByMiniExport(url, data)
  }

  // 抖音券使用情况-人工核销
  dyLifeCouponManual(data) {
    const url = '/open/open/third-life-coupon/verify-dou-dian-code'
    return this.postAjaxByMini(url, data)
  }

  // 抖店影院管理-列表
  dyCinemaSearch(data) {
    const url = '/open/open/cinema-grade/page'
    return this.postAjaxByMini(url, data)
  }

  //抖店影院管理-新增
  dyCinemaAdd(data) {
    const url = '/open/open/cinema-grade/insert'
    return this.postAjaxByMini(url, data)
  }

  // 抖店影院管理-状态更改
  dyCinemaStatus(data) {
    const url = '/open/open/cinema-grade/statusChange'
    return this.postAjaxByMini(url, data)
  }

  // 抖店影院管理-编辑
  dyCinemaEdit(data) {
    const url = '/open/open/cinema-grade/update'
    return this.postAjaxByMini(url, data)
  }

  // 抖店影院管理-删除
  dyCinemaDel(data) {
    const url = '/open/open/cinema-grade/delete'
    return this.postAjaxByMini(url, data)
  }

  // 抖店影院管理-影院列表
  dyCinemaList(data) {
    const url = '/open/open/cinema-grade/cinemaList'
    return this.postAjaxByMini(url, data)
  }

  // 抖店影院管理-影资编码识别
  dyCinemaCode(data) {
    const url = '/open/open/cinema-grade/identifyStandardIds'
    return this.postAjaxByMini(url, data)
  }

  // 抖音商品券同步-列表
  ddCouponGoodsPage(data) {
    const url = '/movie/open/dd-coupon/goods-page'
    return this.postAjaxByMini(url, data)
  }
  ddCouponGoodsPageV3(data) {
    const url = '/movie/open/dd-coupon/goods-page-V3'
    return this.postAjaxByMini(url, data)
  }
  // 抖音商品券同步-更新商品信息
  dyUpdateGoodInfo(data) {
    const url = '/movie/open/dd-coupon/update-good-info'
    return this.postAjaxByMini(url, data)
  }
  dyUpdateGoodInfoV3(data) {
    const url = '/movie/open/dd-coupon/update-good-info-V3'
    return this.postAjaxByMini(url, data)
  }
  // 抖音查询商铺信息
  dyDdCouponQueryShop(data) {
    const url = '/movie/open/dd-coupon/query-shop'
    return this.postAjaxByMini(url, data)
  }
  dyDdCouponQueryShopV3(data) {
    const url = '/movie/open/dd-coupon/query-shop-V3'
    return this.postAjaxByMini(url, data)
  }
  // 同步抖店商品券
  dyDdCouponSyncCoupon(data) {
    const url = '/movie/open/dd-coupon/sync-coupon'
    return this.postAjaxByMini(url, data)
  }
  dyDdCouponSyncCouponV3(data) {
    const url = '/movie/open/dd-coupon/sync-coupon-V3'
    return this.postAjaxByMini(url, data)
  }

  // 淘宝天猫券列表查询
  tmallGoodsSearch(data) {
    const url = '/open/open/tmall-goods/search'
    return this.postAjaxByMini(url, data)
  }
  // 淘宝天猫券新增
  tmallGoodsCreate(data) {
    const url = '/open/open/tmall-goods/create'
    return this.postAjaxByMiniNew(url, data)
  }
  // 淘宝天猫券列表-券使用情况
  tmallCouponSearch(data) {
    const url = '/open/open/tmall-coupon/search'
    return this.postAjaxByMini(url, data)
  }
  // 天猫-优惠券使用情况 - 导出
  tmallhCouponExportDy(data) {
    const url = '/open/open/tmall-coupon/export'
    return this.postAjaxByMiniExport(url, data)
  }

  // 京东券新增
  jdCouponCreate(data) {
    const url = '/open/open/jd-coupon/create'
    return this.postAjaxByMiniNew(url, data)
  }
  // 京东券列表
  jdCouponSearch(data) {
    const url = '/open/open/jd-coupon/search'
    return this.postAjaxByMini(url, data)
  }
  // 导出券码前校验
  jdCouponExportCheck(data) {
    const url = '/open/open/jd-coupon/export/check'
    return this.postAjaxByMini(url, data)
  }
  // 导出券码
  jdCouponExport(data) {
    const url = '/open/open/jd-coupon/export'
    return this.postAjaxByMiniExport(url, data)
  }

  // 抖音poi券列表查询
  couponPoiSearch(data) {
    const url = '/open/open/coupon-template/search'
    return this.postAjaxByMini(url, data)
  }
  //
  uploadMerchant(data) {
    const url = '/movie/open/upload/merchant'
    return this.postAjaxByMini(url, data)
  }
  // poi创建
  poiGoodsSearch(data) {
    const url = '/open/open/coupon-template/create'
    return this.postAjaxByMiniNew(url, data)
  }
  // poi编辑
  poiGoodsEdit(data) {
    const url = '/open/open/coupon-template/edit'
    return this.postAjaxByMiniNew(url, data)
  }

  // 保存模板
  couTemplateSave(data) {
    const url = '/open/open/market/coupon/template/save'
    return this.postAjaxByMiniNew(url, data)
  }

  // 模板列表
  couTemplatePage(data) {
    const url = '/open/open/market/coupon/template/page'
    return this.postAjaxByMiniNew(url, data)
  }

  // 模板详情
  couTemplateDetail(data) {
    const url = '/open/open/market/coupon/template/detail'
    return this.postAjaxByMini(url, data)
  }

  // 支付宝-活动创建-新
  zfbActivityCreateMarket(data) {
    const url = '/open/open/market/coupon/alipay/create'
    return this.postAjaxByMiniNew(url, data)
  }
  // 支付宝-活动编辑-新
  zfbActivityEditMarket(data) {
    const url = '/open/open/market/coupon/alipay/edit'
    return this.postAjaxByMiniNew(url, data)
  }

  // 活动详情-新
  zfbActivityDetailMarket(data) {
    const url = '/open/open/market/coupon/alipay/detail'
    return this.postAjaxByMini(url, data)
  }
  // 停用-新
  zfbActivityStopMarket(data) {
    const url = '/open/open/market/coupon/alipay/stop'
    return this.postAjaxByMini(url, data)
  }
  // 查询数量-新
  zfbQueryQuantityBeforeAppendMarket(data) {
    const url = '/open/open/market/coupon/alipay/queryQuantityBeforeAppend'
    return this.getAjaxByMini(url, data)
  }
  // 追加数量-新
  zfbActivityAppendCodeMarket(data) {
    const url = '/open/open/market/coupon/alipay/appendCode'
    return this.postAjaxByMini(url, data)
  }
  // 支付宝-列表
  zfbActivityPageMarket(data) {
    const url = '/open/open/market/coupon/alipay/page'
    return this.postAjaxByMiniNew(url, data)
  }

  // 活动详情
  couponActivityDetail(data) {
    const url = '/open/open/market/coupon/activity/detail'
    return this.postAjaxByMini(url, data)
  }
  // 活动编辑
  couponActivityEdit(data) {
    const url = '/open/open/market/coupon/activity/edit'
    return this.postAjaxByMiniNew(url, data)
  }
  // 活动列表
  couponActivityPage(data) {
    const url = '/open/open/market/coupon/activity/page'
    return this.postAjaxByMiniNew(url, data)
  }
  // 保存
  couponActivitySave(data) {
    const url = '/open/open/market/coupon/activity/save'
    return this.postAjaxByMiniNew(url, data)
  }

  // 优惠券使用情况-列表
  couponSearchMarket(data) {
    const url = '/open/open/market/coupon/search'
    return this.postAjaxByMini(url, data)
  }

  // 券使用情况-导出
  couponExportV3Market(data) {
    const url = '/open/open/market/coupon/export-v3'
    return this.postAjaxByMini(url, data)
  }
  // 人工核销抖店券码
  verifyDouDianCodeMarket(data) {
    const url = '/open/open/market/coupon/verify-dou-dian-code'
    return this.postAjaxByMini(url, data)
  }
  // 添加备注
  couponRemarkMarket(data) {
    const url = '/open/open/market/coupon/remark'
    return this.postAjaxByMini(url, data)
  }

  // poi-cps管理
  dyLifePlanSearch(data) {
    const url = '/open/open/dy-life/plan/search'
    return this.postAjaxByMini(url, data)
  }
  // 计划创建
  dyLifePlanCreate(data) {
    const url = '/open/open/dy-life/plan/create'
    return this.postAjaxByMiniNew(url, data)
  }
  // 计划编辑
  dyLifePlanEdit(data) {
    const url = '/open/open/dy-life/plan/edit'
    return this.postAjaxByMiniNew(url, data)
  }
  // 计划可选商品列表
  dyLifePlanGoodsList(data) {
    const url = '/open/open/dy-life/plan/goods-list'
    return this.postAjaxByMini(url, data)
  }
  // 商品计划管理
  dyLifePlanGoodsPlan(data) {
    const url = '/open/open/dy-life/plan/goods-plan'
    return this.postAjaxByMini(url, data)
  }
  // 商品计划管理 - 关闭计划
  dyLifePlanClose(data) {
    const url = '/open/open/dy-life/plan/close'
    return this.postAjaxByMini(url, data)
  }
  // 上下架商品
  poiProductOperate(data) {
    const url = '/open/open/coupon-template/product-operate'
    return this.postAjaxByMini(url, data)
  }
  // 影片列表
  movieBaseQuery(data) {
    const url = '/open/open/movie-base/query'
    return this.postAjaxByMini(url, data)
  }
  // 获取 - 渠道商城的appKey
  getChannelAppKey(data) {
    const url = '/movie/open/open-app/get-channel-mall-appKey'
    return this.postAjaxByMini(url, data)
  }
  // 查询 - 渠道商城的appKey
  getChannelMallAppKey(data) {
    const url = '/movie/open/open-app/query-channel-mall-appKey'
    return this.postAjaxByMini(url, data)
  }
  // 添加 - 渠道商城
  addChannelMallAppKey(data) {
    const url = '/movie/open/open-app/add-channel-mall'
    return this.postAjaxByMini(url, data)
  }
  // 修改渠道商城 - 推广设置
  updateChannelMall(data) {
    const url = '/movie/open/open-movie-app-append/update-channel-mall'
    return this.postAjaxByMiniNew(url, data)
  }
  // 修改渠道商城 - 接口设置
  updateChannelMallInterface(data) {
    const url = '/movie/open/open-movie-app-append/update-channel-mall-interface'
    return this.postAjaxByMiniNew(url, data)
  }
  // 查询渠道商城 - 接口设置
  findChannelMallInterface(data) {
    const url = '/movie/open/open-movie-app-append/find-channel-mall-interface'
    return this.postAjaxByMini(url, data)
  }
  // 获取平台信息
  findAppAppend(data) {
    const url = '/movie/open/open-movie-app-append/find-app-append'
    return this.postAjaxByMini(url, data)
  }
  // 城市
  provinceCity(data) {
    const url = '/movie/open/open-movie-app-append/province-city'
    return this.getAjaxByMini(url, data)
  }
  // 推广设置 - 浮动价格设置-列表
  priceFloatList(data) {
    const url = '/movie/open/open-movie-app-append/price-float-setting/query'
    return this.postAjaxByMiniNew(url, data)
  }
  // 推广设置 - 浮动价格设置-新增
  priceFloatSettingAdd(data) {
    const url = '/movie/open/open-movie-app-append/price-float-setting/add'
    return this.postAjaxByMiniNew(url, data)
  }
  // 推广设置 - 浮动价格设置-删除
  priceFloatSettingDelete(data) {
    const url = '/movie/open/open-movie-app-append/price-float-setting/delete'
    return this.postAjaxByMiniNew(url, data)
  }
  // 推广设置 - 浮动价格设置-编辑
  priceFloatSettingUpdate(data) {
    const url = '/movie/open/open-movie-app-append/price-float-setting/update'
    return this.postAjaxByMiniNew(url, data)
  }

}



// WEBPACK FOOTER //
// ./src/api/mini.js